export default {
  en: {
    form: {
      name: {
        label: 'Internal name',
        hint: 'Create an identifier name for availability',
        placeholder: 'Fill a name as identifier'
      },
      duration: {
        label: 'Avg. duration',
        hint: 'Average duration of the meeting to generic available blocks per day',
        placeholder: 'Enter the duration in minutes'
      },
      timezone: {
        label: 'Timezone',
        hint: 'Select the timezone of your agents, not customers'
      },
      minimumToSchedule: {
        label: 'Minimum time to schedule',
        hint: 'Minimum time limit to schedule. Enter 0 to remove a minimum',
        placeholder: 'Minimum value',
      },
      maximumToSchedule: {
        label: 'Maximum time to schedule',
        hint: 'Maximum time limit to schedule.',
        placeholder: 'Maximum value',
      },
      daysAndHours: {
        label: 'Days of weeks',
        hint: 'Availability of schedules of the days of the week',
        empty: 'No availability for {day}',
        rangeStart: 'Start time',
        rangeEnd: 'End time',
        addRange: 'Add range',
        invalidRange: 'Review the ranges of {day}: each range needs a start and an end time, and the start must be earlier than the end'
      },
      blockedDates: {
        label: 'Blocked dates',
        hint: 'Dates not available on the calendar',
        alert: 'This feature is in beta status, it could change in the future',
        empty: 'There are no blackout date',
        addDate: 'Add date',
      }
    }
  },
  es: {
    form: {
      name: {
        label: 'Nombre interno',
        hint: 'Crea un nombre identificador para disponibilidad',
        placeholder: 'Llena un nombre como identificador'
      },
      duration: {
        label: 'Dur. promedio',
        hint: 'Duración promedio de la reunión para bloques disponibles genéricos por día',
        placeholder: 'Ingresa la duración en minutos'
      },
      timezone: {
        label: 'Zona horaria',
        hint: 'Selecciona la zona horaria de tus agentes, no de los clientes'
      },
      minimumToSchedule: {
        label: 'Tiempo mínimo para programar',
        hint: 'Límite de tiempo mínimo para programar. Ingresa 0 para eliminar un mínimo',
        placeholder: 'Valor mínimo',
      },
      maximumToSchedule: {
        label: 'Tiempo máximo para programar',
        hint: 'Límite de tiempo máximo para programar.',
        placeholder: 'Valor máximo',
      },
      daysAndHours: {
        label: 'Días de la semana',
        hint: 'Disponibilidad de horarios de los días de la semana',
        empty: 'No hay disponibilidad para {day}',
        rangeStart: 'Hora de inicio',
        rangeEnd: 'Hora de fin',
        addRange: 'Agregar rango',
        invalidRange: 'Revisa los rangos del {day}: cada rango necesita hora de inicio y de fin, y el inicio debe ser menor que el fin'
      },
      blockedDates: {
        label: 'Fechas bloqueadas',
        hint: 'Fechas no disponibles en el calendario',
        alert: 'Esta función está en estado beta, podría cambiar en el futuro',
        empty: 'No hay fecha de bloqueo',
        addDate: 'Agregar fecha',
      }
    }
  },
  fr: {
    form: {
      name: {
        label: 'Nom interne',
        hint: 'Créez un nom d\'identifiant pour la disponibilité',
        placeholder: 'Entrez un nom comme identifiant'
      },
      duration: {
        label: 'Durée moyenne',
        hint: 'Durée moyenne de la réunion pour les blocs disponibles génériques par jour',
        placeholder: 'Entrez la durée en minutes'
      },
      timezone: {
        label: 'Fuseau horaire',
        hint: 'Sélectionnez le fuseau horaire de vos agents, pas des clients'
      },
      minimumToSchedule: {
        label: 'Temps minimum pour planifier',
        hint: 'Limite de temps minimale pour planifier. Entrez 0 pour supprimer un minimum',
        placeholder: 'Valeur minimale',
      },
      maximumToSchedule: {
        label: 'Temps maximum pour planifier',
        hint: 'Limite de temps maximale pour planifier.',
        placeholder: 'Valeur maximale',
      },
      daysAndHours: {
        label: 'Jours de la semaine',
        hint: 'Disponibilité des horaires des jours de la semaine',
        empty: 'Aucune disponibilité pour {day}',
        rangeStart: 'Heure de début',
        rangeEnd: 'Heure de fin',
        addRange: 'Ajouter une plage',
        invalidRange: 'Vérifiez les plages du {day} : chaque plage nécessite une heure de début et de fin, et le début doit être antérieur à la fin'
      },
      blockedDates: {
        label: 'Dates bloquées',
        hint: 'Dates non disponibles sur le calendrier',
        alert: 'Cette fonctionnalité est en version bêta, elle pourrait changer à l\'avenir',
        empty: 'Il n\'y a pas de date bloquée',
        addDate: 'Ajouter une date',
      }
    }
}

}
